import { useContext, useSyncExternalStore } from 'react';
import { BrazeContext } from 'containers/BrazeProvider';
import { transformBrazeFullScreenInAppMessageDto, transformBrazeModalInAppMessageDto, transformBrazeSlideUpInAppMessageDto } from 'data/transformers/braze';

function useStore(store, transform) {
  const entity = useSyncExternalStore(store.subscribe, () => store.state, () => null);
  if (transform && entity) return transform(entity);
  return entity;
}

function useBrazeInAppMessage() {
  const context = useContext(BrazeContext);
  const modalInAppMessage = useStore(context.modalInAppMessageStore, transformBrazeModalInAppMessageDto);
  const fullScreenInAppMessage = useStore(context.fullScreenInAppMessageStore, transformBrazeFullScreenInAppMessageDto);
  const slideUpInAppMessage = useStore(context.slideUpInAppMessageStore, transformBrazeSlideUpInAppMessageDto);
  return {
    modalInAppMessage: modalInAppMessage !== null && modalInAppMessage !== void 0 ? modalInAppMessage : fullScreenInAppMessage,
    notificationInAppMessage: slideUpInAppMessage
  };
}

export default useBrazeInAppMessage;